import { Injectable, NgModule, defineInjectable } from '@angular/core';
import { Observable } from 'rxjs';
import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
import { utils, write } from 'xlsx';
import { asBlob } from 'html-docx-js/dist/html-docx';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
window['html2canvas'] = html2canvas;
var ExportAsService = /** @class */ (function () {
    function ExportAsService() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    ExportAsService.prototype.get = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        /** @type {?} */
        var func = 'get' + config.type.toUpperCase();
        if (this[func]) {
            return this[func](config);
        }
        return Observable.create(function (observer) { observer.error('Export type is not supported.'); });
    };
    /**
     * @param {?} config
     * @param {?} fileName
     * @return {?}
     */
    ExportAsService.prototype.save = /**
     * @param {?} config
     * @param {?} fileName
     * @return {?}
     */
    function (config, fileName) {
        config.download = true;
        config.fileName = fileName + '.' + config.type;
        this.get(config).subscribe();
    };
    /**
     * @param {?} content
     * @return {?}
     */
    ExportAsService.prototype.contentToBlob = /**
     * @param {?} content
     * @return {?}
     */
    function (content) {
        return Observable.create(function (observer) {
            /** @type {?} */
            var arr = content.split(',');
            /** @type {?} */
            var mime = arr[0].match(/:(.*?);/)[1];
            /** @type {?} */
            var bstr = atob(arr[1]);
            /** @type {?} */
            var n = bstr.length;
            /** @type {?} */
            var u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            observer.next(new Blob([u8arr], { type: mime }));
            observer.complete();
        });
    };
    /**
     * @param {?} fileContent
     * @return {?}
     */
    ExportAsService.prototype.removeFileTypeFromBase64 = /**
     * @param {?} fileContent
     * @return {?}
     */
    function (fileContent) {
        /** @type {?} */
        var re = /^data:[^]*;base64,/g;
        /** @type {?} */
        var newContent = re[Symbol.replace](fileContent, '');
        return newContent;
    };
    /**
     * @param {?} fileContent
     * @param {?} fileMime
     * @return {?}
     */
    ExportAsService.prototype.addFileTypeToBase64 = /**
     * @param {?} fileContent
     * @param {?} fileMime
     * @return {?}
     */
    function (fileContent, fileMime) {
        return "data:" + fileMime + ";base64," + fileContent;
    };
    /**
     * @param {?} fileName
     * @param {?} dataURL
     * @return {?}
     */
    ExportAsService.prototype.downloadFromDataURL = /**
     * @param {?} fileName
     * @param {?} dataURL
     * @return {?}
     */
    function (fileName, dataURL) {
        var _this = this;
        this.contentToBlob(dataURL).subscribe(function (blob) {
            _this.downloadFromBlob(blob, fileName);
        });
    };
    /**
     * @param {?} blob
     * @param {?} fileName
     * @return {?}
     */
    ExportAsService.prototype.downloadFromBlob = /**
     * @param {?} blob
     * @param {?} fileName
     * @return {?}
     */
    function (blob, fileName) {
        /** @type {?} */
        var element = document.createElement('a');
        /** @type {?} */
        var url = window.URL.createObjectURL(blob);
        element.setAttribute('download', fileName);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.href = url;
        element.click();
        document.body.removeChild(element);
    };
    /**
     * @private
     * @param {?} config
     * @return {?}
     */
    ExportAsService.prototype.getPDF = /**
     * @private
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return Observable.create(function (observer) {
            /** @type {?} */
            var jspdf = new jsPDF();
            /** @type {?} */
            var element = document.getElementById(config.elementId);
            jspdf.addHTML(element, function () {
                if (config.download) {
                    jspdf.save(config.fileName);
                    observer.next();
                }
                else {
                    observer.next(jspdf.output('datauristring'));
                }
                observer.complete();
            });
        });
    };
    /**
     * @private
     * @param {?} config
     * @return {?}
     */
    ExportAsService.prototype.getPNG = /**
     * @private
     * @param {?} config
     * @return {?}
     */
    function (config) {
        var _this = this;
        return Observable.create(function (observer) {
            /** @type {?} */
            var element = document.getElementById(config.elementId);
            html2canvas(element, config.options).then(function (canvas) {
                /** @type {?} */
                var imgData = canvas.toDataURL('image/PNG');
                if (config.type === 'png' && config.download) {
                    _this.downloadFromDataURL(config.fileName, imgData);
                    observer.next();
                }
                else {
                    observer.next(imgData);
                }
                observer.complete();
            }, function (err) {
                observer.error(err);
            });
        });
    };
    /**
     * @private
     * @param {?} config
     * @return {?}
     */
    ExportAsService.prototype.getCSV = /**
     * @private
     * @param {?} config
     * @return {?}
     */
    function (config) {
        var _this = this;
        return Observable.create(function (observer) {
            /** @type {?} */
            var element = document.getElementById(config.elementId);
            /** @type {?} */
            var csv = [];
            /** @type {?} */
            var rows = element.querySelectorAll('table tr');
            rows.forEach(function (rowElement, index) {
                /** @type {?} */
                var row = [];
                /** @type {?} */
                var cols = rowElement.querySelectorAll('td, th');
                cols.forEach(function (col, colIndex) {
                    row.push(col.innerText);
                });
                csv.push(row.join(','));
            });
            /** @type {?} */
            var csvContent = 'data:text/csv;base64,' + btoa(csv.join('\n'));
            if (config.download) {
                _this.downloadFromDataURL(config.fileName, csvContent);
                observer.next();
            }
            else {
                observer.next(csvContent);
            }
            observer.complete();
        });
    };
    /**
     * @private
     * @param {?} config
     * @return {?}
     */
    ExportAsService.prototype.getTXT = /**
     * @private
     * @param {?} config
     * @return {?}
     */
    function (config) {
        /** @type {?} */
        var nameFrags = config.fileName.split('.');
        config.fileName = nameFrags[0] + ".txt";
        return this.getCSV(config);
    };
    /**
     * @private
     * @param {?} config
     * @return {?}
     */
    ExportAsService.prototype.getXLS = /**
     * @private
     * @param {?} config
     * @return {?}
     */
    function (config) {
        var _this = this;
        return Observable.create(function (observer) {
            /** @type {?} */
            var element = document.getElementById(config.elementId);
            /** @type {?} */
            var ws3 = utils.table_to_sheet(element, config.options);
            /** @type {?} */
            var wb = utils.book_new();
            utils.book_append_sheet(wb, ws3, config.fileName);
            /** @type {?} */
            var out = write(wb, { type: 'base64' });
            /** @type {?} */
            var xlsContent = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + out;
            if (config.download) {
                _this.downloadFromDataURL(config.fileName, xlsContent);
                observer.next();
            }
            else {
                observer.next(xlsContent);
            }
            observer.complete();
        });
    };
    /**
     * @private
     * @param {?} config
     * @return {?}
     */
    ExportAsService.prototype.getXLSX = /**
     * @private
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return this.getXLS(config);
    };
    /**
     * @private
     * @param {?} config
     * @return {?}
     */
    ExportAsService.prototype.getDOCX = /**
     * @private
     * @param {?} config
     * @return {?}
     */
    function (config) {
        var _this = this;
        return Observable.create(function (observer) {
            /** @type {?} */
            var contentDocument = document.getElementById(config.elementId).outerHTML;
            /** @type {?} */
            var content = '<!DOCTYPE html>' + contentDocument;
            /** @type {?} */
            var converted = asBlob(content, config.options);
            if (config.download) {
                _this.downloadFromBlob(converted, config.fileName);
                observer.next();
                observer.complete();
            }
            else {
                /** @type {?} */
                var reader_1 = new FileReader();
                reader_1.onloadend = function () {
                    /** @type {?} */
                    var base64data = reader_1.result;
                    observer.next(base64data);
                    observer.complete();
                };
                reader_1.readAsDataURL(converted);
            }
        });
    };
    /**
     * @private
     * @param {?} config
     * @return {?}
     */
    ExportAsService.prototype.getDOC = /**
     * @private
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return this.getDOCX(config);
    };
    /**
     * @private
     * @param {?} config
     * @return {?}
     */
    ExportAsService.prototype.getJSON = /**
     * @private
     * @param {?} config
     * @return {?}
     */
    function (config) {
        var _this = this;
        return Observable.create(function (observer) {
            /** @type {?} */
            var data = [];
            // first row needs to be headers
            /** @type {?} */
            var headers = [];
            /** @type {?} */
            var table = (/** @type {?} */ (document.getElementById(config.elementId)));
            for (var index = 0; index < table.rows[0].cells.length; index++) {
                headers[index] = table.rows[0].cells[index].innerHTML.toLowerCase().replace(/ /gi, '');
            }
            // go through cells
            for (var i = 1; i < table.rows.length; i++) {
                /** @type {?} */
                var tableRow = table.rows[i];
                /** @type {?} */
                var rowData = {};
                for (var j = 0; j < tableRow.cells.length; j++) {
                    rowData[headers[j]] = tableRow.cells[j].innerHTML;
                }
                data.push(rowData);
            }
            /** @type {?} */
            var jsonString = JSON.stringify(data);
            /** @type {?} */
            var jsonBase64 = btoa(jsonString);
            /** @type {?} */
            var dataStr = 'data:text/json;base64,' + jsonBase64;
            if (config.download) {
                _this.downloadFromDataURL(config.fileName, dataStr);
                observer.next();
            }
            else {
                observer.next(data);
            }
            observer.complete();
        });
    };
    /**
     * @private
     * @param {?} config
     * @return {?}
     */
    ExportAsService.prototype.getXML = /**
     * @private
     * @param {?} config
     * @return {?}
     */
    function (config) {
        var _this = this;
        return Observable.create(function (observer) {
            /** @type {?} */
            var xml = '<?xml version="1.0" encoding="UTF-8"?><Root><Classes>';
            /** @type {?} */
            var tritem = document.getElementById(config.elementId).getElementsByTagName('tr');
            for (var i = 0; i < tritem.length; i++) {
                /** @type {?} */
                var celldata = tritem[i];
                if (celldata.cells.length > 0) {
                    xml += '<Class name="' + celldata.cells[0].textContent + '">\n';
                    for (var m = 1; m < celldata.cells.length; ++m) {
                        xml += '\t<data>' + celldata.cells[m].textContent + '</data>\n';
                    }
                    xml += '</Class>\n';
                }
            }
            xml += '</Classes></Root>';
            /** @type {?} */
            var base64 = 'data:text/xml;base64,' + btoa(xml);
            if (config.download) {
                _this.downloadFromDataURL(config.fileName, base64);
                observer.next();
            }
            else {
                observer.next(base64);
            }
            observer.complete();
        });
    };
    ExportAsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ExportAsService.ctorParameters = function () { return []; };
    /** @nocollapse */ ExportAsService.ngInjectableDef = defineInjectable({ factory: function ExportAsService_Factory() { return new ExportAsService(); }, token: ExportAsService, providedIn: "root" });
    return ExportAsService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ExportAsModule = /** @class */ (function () {
    function ExportAsModule() {
    }
    ExportAsModule.decorators = [
        { type: NgModule, args: [{
                    providers: [ExportAsService],
                },] }
    ];
    return ExportAsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ExportAsService, ExportAsModule };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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